module.exports = __webpack_public_path__ + "static/media/heavy_vehicle_image.caa3ec00.jpg";